
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/border.st.css.js";
import "../Foundation/stylable/spacing.st.css.js";
import "../Foundation/stylable/easing.st.css.js";

import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_220_3_MediaOverlay";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_220_3_MediaOverlay__root","overlay":"wds_1_220_3_MediaOverlay__overlay","contentRow":"wds_1_220_3_MediaOverlay__contentRow","contentArea":"wds_1_220_3_MediaOverlay__contentArea","hoverEnter":"wds_1_220_3_MediaOverlay__hoverEnter","hoverEnterActive":"wds_1_220_3_MediaOverlay__hoverEnterActive","hoverEnterDone":"wds_1_220_3_MediaOverlay__hoverEnterDone","hoverExit":"wds_1_220_3_MediaOverlay__hoverExit"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-image-border-radius-default":"--wds-image-border-radius-default","wds-shadow-focus-standard":"--wds-shadow-focus-standard","wds-color-fill-transparent-primary":"--wds-color-fill-transparent-primary","wds-space-100":"--wds-space-100","wds-space-200":"--wds-space-200"}; 




